import { ActionTypes } from "../actions/action_types";

const initialState = {
    token: null,
    id: null,
    fullname: null,
    profile_pic: null,
    email: null,
    expiry: null,
    isAuthenticated: false,
    isEmailVerified: false,
}

const RairerReducer = (state=initialState, action) => {
    switch(action.type) {
        case ActionTypes.LOGIN_USER:
            if (!action.payload) return;
            let now_time = new Date();
            let expire_time = now_time.setMinutes(now_time.getMinutes() + action.payload.data.expires_in);
            return ({
                ...state,
                token: action.payload.data.token,
                id: action.payload.data.user.id,
                fullname: action.payload.data.user.name,
                profile_pic: action.payload.profile_picture,
                email: action.payload.data.user.email,
                expiry: expire_time,
                isAuthenticated: true,
                isEmailVerified: action.payload.data.user.email_verified ? true : false,
            })
            
        case ActionTypes.REGISTER_USER:
            let nowr_time = new Date();
            let expirer_time = nowr_time.setMinutes(nowr_time.getMinutes() + action.payload.data.expires_in);
            return ({
                ...state,
                token: action.payload.data.token,
                id: action.payload.data.user.id,
                fullname: action.payload.data.user.name,
                profile_pic: action.payload.profile_picture,
                email: action.payload.data.user.email,
                expiry: expirer_time,
                isAuthenticated: true,
                isEmailVerified: action.payload.data.user.email_verified ? true : false,
            })

        case ActionTypes.VERIFY_USER:
            return ({
                ...state,
                isEmailVerified: action.payload.email_verified,
            })

        case ActionTypes.LOGOUT_USER:
            return ({
                ...initialState
            })
        default:
            return state;
    }
}

export default RairerReducer;